var _defs, _circle, _circle2, _path, _circle3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOccupancyVeryFew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#d1d3d4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250,
    cy: 185.84,
    r: 44.33
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 349.54,
    cy: 195.95,
    r: 33.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.26,307.16c-6.61-41.61-28.39-66.49-65.72-66.49-14.39,0-26.05,3.5-35.77,10.5a35.06,35.06,0,0,0,3.89,3.5c15.94,16.72,26.83,40.83,31.89,71.55,0,1.17.39,2.33.39,3.11C386.1,329.71,418,323.49,415.26,307.16Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 150.45,
    cy: 195.95,
    r: 33.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.73,254.67l3.5-3.5c-9.72-7-21.78-10.5-35.77-10.5-36.94,0-58.72,24.5-65.72,66.49-2.72,16.33,29.55,22.55,65.72,22.55a7.58,7.58,0,0,1,.39-3.11C155.51,295.88,166.4,271.78,182.73,254.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250,358.49c-48.61,0-91.38-8.55-87.88-29.94,9.33-56,38.5-88.66,87.88-88.66s78.55,33.05,87.88,88.66C341.38,349.93,298.61,358.49,250,358.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupancyVeryFew);
export default __webpack_public_path__ + "static/media/occupancyVeryFew.474029d1a24f394d85df0b9ac9046bc1.svg";
export { ForwardRef as ReactComponent };